export interface ScreenerVisitRoute {
  route: 'visitors.invites.show' | 'visitors.entry';
  model: string;
}

/**
 * Maps an RRC Screeners-tab composite visit id ("entry:456" / "invite:123",
 * the VisitCompositeModel shape) to the entry/invite details route. Returns
 * null for a blank id or an unrecognized type so callers no-op rather than
 * transition to a broken route. Route names mirror the visits-table
 * datetime-cell.
 */
export function screenerVisitRoute(visitId: string | null | undefined): ScreenerVisitRoute | null {
  const [type, id] = (visitId ?? '').split(':');
  if (!id) return null;

  switch (type) {
    case 'invite':
      return { route: 'visitors.invites.show', model: id };
    case 'entry':
      return { route: 'visitors.entry', model: id };
    default:
      return null;
  }
}
